import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3afadaa0&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/surex/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afadaa0')) {
      api.createRecord('3afadaa0', component.options)
    } else {
      api.reload('3afadaa0', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=3afadaa0&", function () {
      api.rerender('3afadaa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Home/Home.vue"
export default component.exports